import styled from "styled-components";
import { FormControl, Table } from "react-bootstrap";

export const TableWrapper = styled(Table)`
    // margin-bottom: 0px;

    & > thead > tr > th {
        text-align: center;
        background-color: rgb(221, 221, 221);
        border: 1px solid white !important;
    }

    thead th:first-child {
        border-radius: 4px 0 0 0px;
    }

    thead th:last-child { 
        border-radius: 0 4px 0px 0;

    }

    & > tbody > tr:first-child > td,
    & > tbody > tr:first-child > th {
        border-top: none;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }

    & > tbody > tr > td:first-child {
        // text-align: left;
    }

    & > thead > tr:first-child > th {
        height: 30px;
        white-space: nowrap;
        width: 35px;
        background-color:rgb(40,96,144);
        border:none;
        color:#FFF;
    }


    & > thead > tr > th:first-child {
            width:auto;
    }

    & > thead > tr > th > div {
        text-align: left !important;
        transform: translate(30px, -1px) rotate(315deg);
        width: 35px;
        padding-left: 5px
    }
    & > thead > tr > th > div > span {
        display: block;
        border-bottom: 1px solid #CCC;
        width: 200px;
    }


   & > thead > tr:last-child > th:nth-child(n+3) {
         background-color:white;white-space: nowrap;
            text-align: center;
        border: 1px solid #CCC !important;
    }


    & tfoot > tr {
        text-align: center;
        background-color:rgb(131,175,221);
    }
`;

export const NavSubWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    // margin-bottom: 20px;
    // border: 1px solid red;

    & > div > .acc-pills > li > a {
        padding: 5px 7px;
    }

    & > div > .acc-pills > li > span {
        position: relative;
        display: block;
        font-size: 12px;
        padding: 5px 7px;
        color: #ccc;
    }

    & > div > .acc-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        margin-top: 9px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
        // border: 0.5px solid #ccc
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            font-size: 12px;
            min-width: 120px;
        }
    }

     .btn-bg.active {
      color: white;
      background-color: #286090 !important;
    }
`;

export const SearchTableWrapper = styled(TableWrapper)`
    & > thead > tr > th {
        font-size: 12px;
        border: 1px solid white !important;
    }

    & > tbody > tr > td {
        font-size: 12px;
    }
`;

export const RowWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    & > div {
        text-align: center;
    }
`;

export const AmountWrapper = styled(FormControl)`
    text-align: center;
`;

export const ContentWrapper = styled.div`
    width: 100%;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    min-height: 70vh;
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: #FFF;
    border-radius: 4px;
`;

export const ConfirmTableWrapper = styled(Table)`
    & > tbody > tr > th {
        width: 25%;
        background-color: #eee;
        text-align: right;
    }

    & > tbody > tr > td {
        padding-left: 20px;
    }
`;

export const FilterWrapper = styled.div`
     .btn-bg.active {
      color: white;
      background-color: #286090 !important;
    }
`;

export const OpportunitiesTableWrapper = styled(Table)`
    & > thead > tr > th:nth-child(1),
    & > thead > tr > th:nth-child(2),
    & > thead > tr > th:nth-child(3),
    & > tbody > tr > td:nth-child(1),
    & > tbody > tr > td:nth-child(2),
    & > tbody > tr > td:nth-child(3) {
        text-align: center;
        vertical-align: middle;
    }
`;
